// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c70eb216","455":"643dfaee","977":"5b0fa8c7"}[chunkId] + ".chunk.js";
};